define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");
    const WidgetScaleMode     = require("shared/ui/experience/widgets/WidgetScaleMode");

    const Direction = {
        HORIZONTAL: "horizontal",
        VERTICAL: "vertical"
    };

    /**
     * Model for a scene navigator widget.
     *
     * @class SceneNavigatorWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Scene navigator", {
        defaults: _.defaults({
            type: "scene-navigator",
            direction: Direction.HORIZONTAL,
            theme: "white-1",
            // The scene navigator widget will be stretched (scaled) when the experience is
            // resized. When we get a proper responsive widget layout in place, this should be removed.
            scaleMode: WidgetScaleMode.STRETCH
        }, AbstractWidgetModel.prototype.defaults),

        getScaledSize() {
            // Scaling is not supported by the navigator widget - sizing is
            // determined by the 'size' property and the number of scenes
            return {};
        }

    }, {
        Direction
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetModel.js